import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BillingUiModule } from '@vendasta/billing-ui';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { ItemCommonModule } from '../common/item-common.module';
import { InventoryUiI18nModule } from '../i18n/inventory-ui-i18n.module';
import { PackageContentsPopoverModule } from '../common/package-contents-popover/package-contents-popover.module';
import { ItemConflictService } from '../services/item-conflict.service';
import { ItemDependencyService } from '../services/item-dependency.service';
import { LineItemCacheService } from '../services/line-item-cache.service';
import { ItemSelectorServiceV2 } from './item-selector-v2.service';
import { ItemSelectorComponent } from './item-selector.component';
import { FormatDisabledItemPipe } from './pipes/format-disabled-item.pipe';
import { FormatProductRequirementPipe } from './pipes/format-product-requirement.pipe';
import { FormatProductTypePipe } from './pipes/format-product-type.pipe';
import { IsItemDisabledPipe } from './pipes/is-item-disabled.pipe';
import { ParseWholesaleCurrencyPipe } from './pipes/parse-wholesale-currency.pipe';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';

const MAT_MODULES = [
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatChipsModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatSelectModule,
  MatTableModule,
  MatTooltipModule,
  FormsModule,
];

const GALAXY_MODULES = [
  GalaxyTableModule,
  GalaxyAvatarModule,
  GalaxyInputModule,
  GalaxyFormFieldModule,
  GalaxyLoadingSpinnerModule,
  GalaxyPopoverModule,
  GalaxyTooltipModule,
  GalaxyBadgeModule,
];

export const ITEM_SELECTOR_MODULE_IMPORTS = [
  ...MAT_MODULES,
  ...GALAXY_MODULES,
  BillingUiModule,
  CommonModule,
  InventoryUiI18nModule,
  ItemCommonModule,
  ProductAnalyticsModule,
  PackageContentsPopoverModule,
  TranslateModule,
];

export const ITEM_SELECTOR_MODULE_DECLARATIONS = [
  ItemSelectorComponent,
  FormatProductTypePipe,
  FormatProductRequirementPipe,
  ParseWholesaleCurrencyPipe,
  IsItemDisabledPipe,
  FormatDisabledItemPipe,
];

export const ITEM_SELECTOR_MODULE_PROVIDERS = [
  ItemSelectorServiceV2,
  LineItemCacheService,
  ItemConflictService,
  ItemDependencyService,
];

@NgModule({
  imports: ITEM_SELECTOR_MODULE_IMPORTS,
  exports: [ItemSelectorComponent],
  declarations: ITEM_SELECTOR_MODULE_DECLARATIONS,
  providers: ITEM_SELECTOR_MODULE_PROVIDERS,
})
export class ItemSelectorModule {}
